<ion-content class="ion-padding">
  <usucampeao-documentos-upload [tipo]="tipo" [documentoId]="documentoId" [arquivos]="arquivos" (aoRealizarUpload)="adicionarOuAtualizarDocumento($event)"></usucampeao-documentos-upload>
</ion-content>
